const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };
};

/**
 * GET /api/v1/admin/jobs
 * List jobs with pagination, filters, and search
 * @param {Object} params - { page, limit, name, eventType, status, orderId, userId, userName, userMobile, search, sortBy, sortOrder }
 */
export const listJobs = async (params = {}) => {
  const queryParams = new URLSearchParams();
  const { page, limit, name, eventType, status, orderId, userId, userName, userMobile, search, sortBy, sortOrder } = params;
  if (page != null) queryParams.append('page', String(page));
  if (limit != null) queryParams.append('limit', String(limit));
  if (name) queryParams.append('name', name);
  if (eventType) queryParams.append('eventType', eventType);
  if (status) queryParams.append('status', status);
  if (orderId != null && orderId !== '') queryParams.append('orderId', String(orderId));
  if (userId) queryParams.append('userId', userId);
  if (userName) queryParams.append('userName', userName);
  if (userMobile) queryParams.append('userMobile', userMobile);
  if (search) queryParams.append('search', search);
  if (sortBy) queryParams.append('sortBy', sortBy);
  if (sortOrder) queryParams.append('sortOrder', sortOrder);

  const qs = queryParams.toString();
  const response = await fetch(`${API_URL}/api/v1/admin/jobs${qs ? `?${qs}` : ''}`, {
    headers: getAuthHeaders(),
  });
  return response.json();
};

/**
 * GET /api/v1/admin/jobs/stats
 * Dashboard stats (optionally filtered by orderId, userId, userName, userMobile, name, eventType)
 */
export const getJobStats = async (params = {}) => {
  const queryParams = new URLSearchParams();
  const { orderId, userId, userName, userMobile, name, eventType } = params;
  if (orderId != null && orderId !== '') queryParams.append('orderId', String(orderId));
  if (userId) queryParams.append('userId', userId);
  if (userName) queryParams.append('userName', userName);
  if (userMobile) queryParams.append('userMobile', userMobile);
  if (name) queryParams.append('name', name);
  if (eventType) queryParams.append('eventType', eventType);

  const qs = queryParams.toString();
  const response = await fetch(`${API_URL}/api/v1/admin/jobs/stats${qs ? `?${qs}` : ''}`, {
    headers: getAuthHeaders(),
  });
  return response.json();
};

/**
 * GET /api/v1/admin/jobs/names
 * Distinct job names for filter dropdown
 */
export const getJobNames = async () => {
  const response = await fetch(`${API_URL}/api/v1/admin/jobs/names`, {
    headers: getAuthHeaders(),
  });
  return response.json();
};

/**
 * GET /api/v1/admin/jobs/events
 * Distinct event types (data.event) for filter dropdown
 */
export const getEventTypes = async () => {
  const response = await fetch(`${API_URL}/api/v1/admin/jobs/events`, {
    headers: getAuthHeaders(),
  });
  return response.json();
};

/**
 * GET /api/v1/admin/jobs/:jobId
 */
export const getJobById = async (jobId) => {
  const response = await fetch(`${API_URL}/api/v1/admin/jobs/${jobId}`, {
    headers: getAuthHeaders(),
  });
  return response.json();
};

/**
 * POST /api/v1/admin/jobs
 * Create/schedule job
 * @param {Object} body - { name, data?, runAt? }
 */
export const createJob = async (body) => {
  const response = await fetch(`${API_URL}/api/v1/admin/jobs`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify(body),
  });
  return response.json();
};

/**
 * PATCH /api/v1/admin/jobs/:jobId
 * Update job (nextRunAt, disabled, data)
 */
export const updateJob = async (jobId, body) => {
  const response = await fetch(`${API_URL}/api/v1/admin/jobs/${jobId}`, {
    method: 'PATCH',
    headers: getAuthHeaders(),
    body: JSON.stringify(body),
  });
  return response.json();
};

/**
 * POST /api/v1/admin/jobs/:jobId/retry
 */
export const retryJob = async (jobId) => {
  const response = await fetch(`${API_URL}/api/v1/admin/jobs/${jobId}/retry`, {
    method: 'POST',
    headers: getAuthHeaders(),
  });
  return response.json();
};

/**
 * DELETE /api/v1/admin/jobs/:jobId
 */
export const deleteJob = async (jobId) => {
  const response = await fetch(`${API_URL}/api/v1/admin/jobs/${jobId}`, {
    method: 'DELETE',
    headers: getAuthHeaders(),
  });
  return response.json();
};
